<div class="table-container">
  <div class="data-card">
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>

        <!-- Creativity Table -->
        <ng-container matColumnDef="creativityList">
            <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                <div class="creativity-detail" [class.expanded]="row.id == expandedCampaign?.id">
                  @if(row.id == expandedCampaign?.id) {
                    <streaming-campaign-creativity-grid-component
                      #creativityGrid
                      [parentCampaign]="row"
                      style="width:100%;">
                    </streaming-campaign-creativity-grid-component>
                  }
                </div>
            </td>
        </ng-container>

        <!-- Campaign Title Column -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Campaign Title </th>
          <td mat-cell *matCellDef="let row"> {{row.title}} </td>
        </ng-container>

        <!-- Brand Column -->
        <ng-container matColumnDef="brand">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Brand </th>
          <td mat-cell *matCellDef="let row"> {{row.brand}} </td>
        </ng-container>

        <!-- Agency/Office Column -->
        <ng-container matColumnDef="agency">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Agency/Office </th>
          <td mat-cell *matCellDef="let row">
            {{row.agency | objectdesc}}
            <div class="cell-secondary">{{row.commercialOffice | objectdesc}}</div>
          </td>
        </ng-container>

        <!-- Created Column -->
        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Created </th>
          <td mat-cell *matCellDef="let row"> {{row.dateCreated | date:'d/M/yyyy'}} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let row">
            <div class="actions">
              <button matButton class="act-btn" (click)="onEditCampaign(row)" matTooltip="Edit Campaign">
                <i class="fa-solid fa-pen"></i>
              </button>
              <button matButton class="act-btn" (click)="onAddCreativity(row)" matTooltip="Add Creativities to Campaign">
                <i class="fa-solid fa-rectangle-ad"></i>
              </button>
              <!-- <button matButton class="act-btn" (click)="onViewHistory(row)" matTooltip="View History">
                <i class="fa-regular fa-message"></i>
              </button> -->
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="onExpandCampaign(row)"></tr>
        <tr mat-row *matRowDef="let row; columns: ['creativityList'];" class="creativity-detail-row"></tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      aria-label="Select page">
    </mat-paginator>
  </div>
</div>
